var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-header-container"},[_c('div',{staticClass:"table-header",class:{ flexStart: _vm.flexStart }},[_vm._t("default")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }